import CmdEnum from '@/constants/CmdEnum';
import HotKeyScope from '@/constants/HotKeyScope';
import KeyCodeMap from '@/constants/KeyCode';
import cmdMaps, { CmdItem } from './cmd';

export interface HotKey extends CmdItem {
  /** 作用范围分组 */
  scope: HotKeyScope;

  /** 键值 - 支持多个键同一个功能 */
  keyCode: number | number[];

  /** 是否按下ctrl/command */
  ctrlKey?: boolean;

  /** 是否按下shift */
  shiftKey?: boolean;

  /** 是否按下alt/option */
  altKey?: boolean;

  /** 组合键 */
  combination?: string;
}

const hotKeyMaps: HotKey[] = [
  {
    ...cmdMaps[CmdEnum.COPY],
    scope: HotKeyScope.COMPONENT,
    combination: '⌘C/CTRL+C',
    keyCode: KeyCodeMap.C,
    ctrlKey: true,
  },
  {
    ...cmdMaps[CmdEnum.CUT],
    scope: HotKeyScope.COMPONENT,
    combination: '⌘X/CTRL+X',
    keyCode: KeyCodeMap.X,
    ctrlKey: true,
  },
  {
    ...cmdMaps[CmdEnum.PASTE],
    scope: HotKeyScope.COMPONENT,
    combination: '⌘V/CTRL+V',
    keyCode: KeyCodeMap.V,
    ctrlKey: true,
  },
  {
    ...cmdMaps[CmdEnum.UNDO],
    scope: HotKeyScope.COMPONENT,
    combination: '⌘Z/CTRL+Z',
    keyCode: KeyCodeMap.Z,
    ctrlKey: true,
  },
  {
    ...cmdMaps[CmdEnum.REDO],
    scope: HotKeyScope.COMPONENT,
    combination: '⇧⌘Z/SHIFT+CTRL+Z',
    keyCode: KeyCodeMap.Z,
    shiftKey: true,
    ctrlKey: true,
  },
  {
    ...cmdMaps[CmdEnum.DELETE],
    scope: HotKeyScope.COMPONENT,
    combination: '⌫ | Del/BACKSPACE | Del',
    keyCode: [KeyCodeMap.BACKSPACE, KeyCodeMap.DELETE],
  },
  {
    ...cmdMaps[CmdEnum['SELECT ALL']],
    scope: HotKeyScope.COMPONENT,
    combination: 'CTRL+A',
    keyCode: KeyCodeMap.A,
    ctrlKey: true,
  },
  {
    ...cmdMaps[CmdEnum['TO UP']],
    scope: HotKeyScope.COMPONENT,
    combination: '↑',
    keyCode: KeyCodeMap.UP,
  },
  {
    ...cmdMaps[CmdEnum['TO BUTTOM']],
    scope: HotKeyScope.COMPONENT,
    combination: '↓',
    keyCode: KeyCodeMap.DOWN,
  },
  {
    ...cmdMaps[CmdEnum['TO LEFT']],
    scope: HotKeyScope.COMPONENT,
    combination: '←',
    keyCode: KeyCodeMap.LEFT,
  },
  {
    ...cmdMaps[CmdEnum['TO RIGHT']],
    scope: HotKeyScope.COMPONENT,
    combination: '→',
    keyCode: KeyCodeMap.RIGHT,
  },
  {
    ...cmdMaps[CmdEnum['TO UP 10PX']],
    scope: HotKeyScope.COMPONENT,
    combination: '↑',
    keyCode: KeyCodeMap.UP,
    shiftKey: true,
  },
  {
    ...cmdMaps[CmdEnum['TO BUTTOM 10PX']],
    scope: HotKeyScope.COMPONENT,
    combination: '↓',
    keyCode: KeyCodeMap.DOWN,
    shiftKey: true,
  },
  {
    ...cmdMaps[CmdEnum['TO LEFT 10PX']],
    scope: HotKeyScope.COMPONENT,
    combination: '←',
    keyCode: KeyCodeMap.LEFT,
    shiftKey: true,
  },
  {
    ...cmdMaps[CmdEnum['TO RIGHT 10PX']],
    scope: HotKeyScope.COMPONENT,
    combination: '→',
    keyCode: KeyCodeMap.RIGHT,
    shiftKey: true,
  },
];

export default hotKeyMaps;
